import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITochiAnimation } from "@snackpass/snackpass-types";
import { AnimationClip } from "three";
import { StoreState } from ".";

export const getAnimsDict = (state: StoreState) =>
  state.tochiAnimation.animations;
export const getActiveAnim = (state: StoreState) => state.tochiAnimation.active;
export const getAnimClips = (state: StoreState) => state.tochiAnimation.clips;

export type TochiAnimationReduxType = {
  animations: { [name: string]: ITochiAnimation };
  active: { name: string; updated: Date };
  clips: AnimationClip[];
};

const tochiAnimationSlice = createSlice({
  name: "tochiAnimation",
  initialState: {
    animations: {},
    active: { name: "idle", updated: new Date() },
    clips: [],
  } as TochiAnimationReduxType,
  reducers: {
    setAnims: (
      state: TochiAnimationReduxType,
      action: PayloadAction<ITochiAnimation[]>
    ) => {
      const result: { [id: string]: ITochiAnimation } = {};
      action.payload.forEach((anim: ITochiAnimation) => {
        result[anim.name] = anim;
      });
      state.animations = result;
      return state;
    },
    setActiveAnim: (
      state: TochiAnimationReduxType,
      action: PayloadAction<string>
    ) => {
      state.active = { name: action.payload, updated: new Date() };
      return state;
    },
    setAnimClips: (
      state: TochiAnimationReduxType,
      action: PayloadAction<AnimationClip[]>
    ) => {
      state.clips = action.payload;
      return state;
    },
  },
});

export const { setAnims, setActiveAnim, setAnimClips } =
  tochiAnimationSlice.actions;
export const tochiAnimationReducer = tochiAnimationSlice.reducer;
